//
//
//
//
//
//
//
//

export default {
  name: 'error',
  props: {
    errorMsg: {}
  },
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/error.vue